import storeDesktop, { rootActionsDesktop, useAppDispatchDesktop, useAppSelectorDesktop } from './data/store-desktop';
import storeMobile, { useAppSelectorMobile, rootActionsMobile, useAppDispatchMobile } from './data/store-mobile';
import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import Notifications from './ui/main';

export interface IStoreProps {
    useAppSelector: typeof useAppSelectorDesktop,
    rootActions: typeof rootActionsDesktop,
    useAppDispatch: typeof useAppDispatchDesktop,
}

const initDesktop = () => {
    const $rootDesktop = document.getElementById('header-notifications-placeholder');
    if (!$rootDesktop) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ storeDesktop }>
                <Notifications
                    isMobile={ false }
                    storeProps={{
                        useAppSelector: useAppSelectorDesktop,
                        rootActions: rootActionsDesktop,
                        useAppDispatch: useAppDispatchDesktop,
                    }}
                />
            </Provider>
        </React.StrictMode>,
        $rootDesktop
    );
};

const initMobile = () => {
    const $rootMobile = document.getElementById('header-notifications-m-placeholder');
    if (!$rootMobile) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ storeMobile }>
                <Notifications
                    isMobile={ true }
                    storeProps={{
                        useAppSelector: useAppSelectorMobile,
                        rootActions: rootActionsMobile,
                        useAppDispatch: useAppDispatchMobile,
                    }}
                />
            </Provider>
        </React.StrictMode>,
        $rootMobile
    );
};

export const initNotifications = () => {
    initDesktop();
    initMobile();
};